import request from "@/utils/request";
import { API_ENDPOINTS } from "@/constants/ApiEndpoints";

/**
 * Fetch all mentorship rounds.
 */
export const getAllMentorshipRounds = () =>
  request.get(API_ENDPOINTS.MENTORSHIP_ROUNDS);

/**
 * Fetch the mentorship partners for a specific round.
 * @param {string} roundId - Optional: the ID of the mentorship round.
 */
export const getMyMentorshipPartners = (roundId) =>
  request.get(API_ENDPOINTS.MENTORSHIP_PARTNERS, {
    params: { round_id: roundId },
  });

/**
 * Fetch the mentorship registration information for a specific round.
 * @param {string} roundId - The ID of the mentorship round.
 */
export const getMyMentorshipRegistration = (roundId) =>
  request.get(API_ENDPOINTS.MENTORSHIP_REGISTRATION(roundId));

/**
 * Fetch the mentorship match result for a specific round.
 * @param {string} roundId - The ID of the mentorship round.
 */
export const getMyMentorshipMatchResult = (roundId) =>
  request.get(API_ENDPOINTS.MENTORSHIP_MATCH_RESULT(roundId));

/**
 * Register for a specific mentorship round with the provided data.
 * @param {string} roundId - The ID of the mentorship round.
 * @param {object} data - The registration data.
 */
export const postMyMentorshipRegistration = (roundId, data) =>
  request.post(API_ENDPOINTS.MENTORSHIP_REGISTRATION(roundId), data);

/** Fetch the mentorship meeting log for a specific round
 * @param {string} roundId - The ID of the mentorship round.
 */
export const getMyMentorshipMeetingLog = (roundId) =>
  request.get(API_ENDPOINTS.MENTORSHIP_MEETINGS_ENDPOINT, {
    params: { round_id: roundId },
  });

/** Submit the mentorship meeting log for a specific round
 * @param {object} data - The meeting log data
 */
export const postMyMentorshipMeetingLog = (data) =>
  request.post(API_ENDPOINTS.MENTORSHIP_MEETINGS_ENDPOINT, data);

/**
 * Fetch meetings by roundId for Mentorship V2.
 * @param {string} roundId - The ID of the mentorship round.
 */
export const getMyMentorshipMeetingsV2 = ({ roundId, includeDetails }) =>
  request.get(API_ENDPOINTS.MENTORSHIP_MEETINGS_V2, {
    params: {
      round_id: roundId,
      include_details: includeDetails,
    },
  });

/**
 * Create a mentorship meeting V2.
 * @param {object} data - The meeting data to be created.
 */
export const postMyMentorshipMeetingV2 = (data) =>
  request.post(API_ENDPOINTS.MENTORSHIP_MEETINGS_V2, data);

/**
 * Fetch the current user's program feedback for a specific round.
 * @param {string} roundId - The ID of the mentorship round.
 */
export const getMyMentorshipFeedback = (roundId) =>
  request.get(API_ENDPOINTS.MENTORSHIP_FEEDBACK(roundId));

/**
 * Submit or overwrite program feedback for a specific round.
 * @param {string} roundId - The ID of the mentorship round.
 * @param {object} data - The feedback payload.
 */
export const postMyMentorshipFeedback = (roundId, data) =>
  request.post(API_ENDPOINTS.MENTORSHIP_FEEDBACK(roundId), data);
